export enum MeetingRoomScheduleSortType {
    Id,
    FromDateTime,
    ToDateTime,
    MeetingRoomName,
    CustomerName,
    Description,
    IsDeleted,

    // front-end
    Employee
}
